export const formatShortcutKeys = (keys: string): string => {
  if (!keys) return ''
  return keys
    .split('+')
    .map((part) => {
      if (part === 'cmd') return '⌘'
      return part.charAt(0).toUpperCase() + part.slice(1)
    })
    .join('+')
}
